var exports = {
  "m4": "Octicon__4C6ML7",
  "JU": "Label__AGHNL7",
  "az": "Box__TqUjkI",
  "wy": "Box_1__drcn9N",
  "pv": "Box_2__9l57iL",
  "w9": "Box_3__IJ23nQ",
  "pQ": "Box_4__kMTrRr",
  "PO": "iconSuccess__-XsOU2",
  "Zj": "iconDanger__B2qoxH",
};

module.exports = exports;
